import { VISITOR_STORAGE_KEY, normalizeVisitorId, isStatisticsCrawler } from '../config/visitorStatistics.mjs';

export async function getAnonymousVisitorId(): Promise<string | null> {
  try {
    if (isStatisticsCrawler(navigator.userAgent)) return null;
    const existing = normalizeVisitorId(window.localStorage.getItem(VISITOR_STORAGE_KEY));
    if (existing) return existing;
    // 최초 생성은 탭 사이에서도 잠근다. 잠금 미지원 시 불안정한 ID를 집계하지 않는다.
    if (!navigator.locks?.request || !window.crypto?.randomUUID) return null;
    return await navigator.locks.request(VISITOR_STORAGE_KEY, { mode: 'exclusive' }, () => {
      const shared = normalizeVisitorId(window.localStorage.getItem(VISITOR_STORAGE_KEY));
      if (shared) return shared;
      const created = normalizeVisitorId(window.crypto.randomUUID());
      if (!created) return null;
      window.localStorage.setItem(VISITOR_STORAGE_KEY, created);
      return window.localStorage.getItem(VISITOR_STORAGE_KEY) === created ? created : null;
    });
  } catch {
    return null;
  }
}
